export class UsanFormSectionStates {
  showBasicInfoPanel: boolean = true;
  showMolecularInfoPanel: boolean = false;
  showSubstanceDetailsPanel: boolean = false;
  showManufactureUsageInfoPanel: boolean = false;
  showClinicalTrialInfoPanel: boolean = false;
  showApplicantInfoPanel: boolean = false;
  showPaymentInfoPanel: boolean = false;
  showUploadDocumentsPanel: boolean = false;
  showTermsAndConditionsPanel: boolean = false;

  public resetAll() {
    this.showBasicInfoPanel = false;
    this.showMolecularInfoPanel = false;
    this.showSubstanceDetailsPanel = false;
    this.showManufactureUsageInfoPanel = false;
    this.showClinicalTrialInfoPanel = false;
    this.showApplicantInfoPanel = false;
    this.showPaymentInfoPanel = false;
    this.showUploadDocumentsPanel = false;
    this.showTermsAndConditionsPanel = false;
  }

  public updateShownPanel(panelName: string) {
    this.resetAll();
    this[panelName] = true;
  }

}